module.exports = __webpack_public_path__ + "img/nl.ff18a53b.png";